import "../sharedLandingcss/Site.css";
import "../sharedLandingcss/Site_Animate.css";
import PagerHeaderComp from "../sharedLandingcomponents/PagesHeaderComp";
import PortServicesComp from "../sharedLandingcomponents/portfolio_Service";

const ServicesPage = () => {
  return (
    <div className="min-h-[400px]">
      <PagerHeaderComp title="Our Services" />
      <div className="container mx-auto px-4 py-8">
        {<PortServicesComp></PortServicesComp>}
      </div>
    </div>
  );
};

export default ServicesPage;
